var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 120,
    viewBox: "0 0 122 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6791 2C49.0105 2 62.3009 20.5687 49.0105 16.2836C38.3783 12.8555 36.5257 19.6164 35.7202 23.4254H23.6384C23.6384 16.5692 15.5837 13.903 11.5563 13.4269V4.85673C11.1534 4.85673 14.214 2 29.6791 2Z",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5226 117.84C5.80917 117.84 2.79375 99.5884 2.00021 90.4628C2.00021 81.4033 5.17435 73.9915 6.76142 71.418C8.34848 69.0374 12.4749 63.8 16.2838 61.8956C20.0928 59.9911 21.045 54.7538 21.045 52.3732V30.9478H38.8995V46.4217C52.2309 60.7053 57.1508 76.9727 57.9443 83.321V99.9852C57.9443 107.603 52.3896 115.062 49.6122 117.84H11.5226Z",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.10235,
    y: -1.10235,
    width: 15.2047,
    height: 6.20469,
    transform: "matrix(-1 0 0 1 39.149 25.2871)",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1.10235,
    y: -1.10235,
    width: 8.20469,
    height: 4.20469,
    transform: "matrix(4.37114e-08 1 1 -4.37114e-08 7.94434 6.28711)",
    stroke: "#007EBD",
    strokeWidth: 2.20469,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M104.925 29.1299C104.925 29.1299 103.309 34.71 100.803 37.2164C98.2967 39.7227 92.7166 41.3381 92.7166 41.3381C92.7166 41.3381 98.2967 42.9535 100.803 45.4598C103.309 47.9662 104.925 53.5463 104.925 53.5463C104.925 53.5463 106.54 47.9662 109.047 45.4598C111.553 42.9535 117.133 41.3381 117.133 41.3381C117.133 41.3381 111.553 39.7227 109.047 37.2164C106.54 34.71 104.925 29.1299 104.925 29.1299Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9126 16.7729C81.9126 16.7729 80.601 21.3036 78.5661 23.3386C76.5311 25.3736 72.0004 26.6852 72.0004 26.6852C72.0004 26.6852 76.5311 27.9967 78.5661 30.0317C80.601 32.0667 81.9126 36.5974 81.9126 36.5974C81.9126 36.5974 83.2241 32.0667 85.2591 30.0317C87.2941 27.9967 91.8248 26.6852 91.8248 26.6852C91.8248 26.6852 87.2941 25.3736 85.2591 23.3386C83.2241 21.3036 81.9126 16.7729 81.9126 16.7729Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.942 3.28711C100.942 3.28711 99.9017 6.8805 98.2877 8.4945C96.6737 10.1085 93.0803 11.1487 93.0803 11.1487C93.0803 11.1487 96.6737 12.189 98.2877 13.803C99.9017 15.417 100.942 19.0104 100.942 19.0104C100.942 19.0104 101.982 15.417 103.596 13.803C105.21 12.189 108.804 11.1487 108.804 11.1487C108.804 11.1487 105.21 10.1085 103.596 8.4945C101.982 6.8805 100.942 3.28711 100.942 3.28711Z",
    stroke: "#007EBD",
    strokeWidth: 1.65352,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.401 109.859H61.4077",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2434 90.5962H62.6118",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59 59.2935H109.566C113.178 59.2935 120.402 61.2198 120.402 68.9251C120.402 76.6304 120.402 100.228 120.402 111.063C120.803 113.471 119.92 118.287 113.178 118.287C106.436 118.287 74.2501 118.287 59 118.287",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8159 56.8856V50.8659C63.8159 49.2606 64.7791 46.05 68.6317 46.05C72.4844 46.05 82.2765 46.05 86.691 46.05C88.2963 46.05 91.5068 47.0132 91.5068 50.8659C91.5068 54.7185 91.5068 56.4843 91.5068 56.8856",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M119.198 89.3921L83.0791 90.596",
    stroke: "#007EBD",
    strokeWidth: 2.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70.9354,
    y: 82.0648,
    width: 12.2474,
    height: 17.0632,
    rx: 3.9,
    stroke: "#007EBD",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveIcon);
export default __webpack_public_path__ + "static/media/moveIcon.69802d8ff223dcf60f57129d0ceb8e0f.svg";
export { ForwardRef as ReactComponent };